<div class="printButton">
  <a
    target="_blank"
    rel="noopener noreferrer"
    [routerLink]="route"
    (click)="prepareData()"
    [disabled]="data == null"
    mat-button
  >
    <svg-icon
      *ngIf="!printButtonTemplate"
      src="../../../../assets/icons/printer.svg"
      [svgStyle]="{
        'width.rem': 0.875,
        position: 'relative',
        'top.rem': 0.15
      }"
    ></svg-icon>
    <ng-container
      *ngTemplateOutlet="
        printButtonTemplate ? printButtonTemplate : defaultPrintButton
      "
    >
    </ng-container>
  </a>
</div>

<ng-template #defaultPrintButton
  ><span class="print-button">Imprimir</span></ng-template
>
